import { State } from 'common/store/reducers';

const selectPublisherAccounts = (state: State) => state.parentPublisherSettings.accounts;
const selectPublisherAccountsParents = (state: State) => state.parentPublisherSettings.accountsParents;

export const parentPublisherSettingsSelectors = {
  selectPublisherAccounts,
  selectPublisherAccountsParents,
};
